import type { IconProps } from './../../models/icon';

export function LogoutIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M16.2855 21.4286C16.2855 21.8832 16.1049 22.3193 15.7834 22.6408C15.4619 22.9622 15.0259 23.1429 14.5712 23.1429H2.57122C2.11656 23.1429 1.68053 22.9622 1.35904 22.6408C1.03755 22.3193 0.856934 21.8832 0.856934 21.4286V2.57146C0.856934 2.1168 1.03755 1.68077 1.35904 1.35928C1.68053 1.03779 2.11656 0.857178 2.57122 0.857178H14.5712C15.0259 0.857178 15.4619 1.03779 15.7834 1.35928C16.1049 1.68077 16.2855 2.1168 16.2855 2.57146V21.4286Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M16.2855 18V21.4286C16.2855 21.8832 16.1049 22.3193 15.7834 22.6408C15.4619 22.9622 15.0259 23.1429 14.5712 23.1429H2.57122C2.11656 23.1429 1.68053 22.9622 1.35904 22.6408C1.03755 22.3193 0.856934 21.8832 0.856934 21.4286V2.57146C0.856934 2.1168 1.03755 1.68077 1.35904 1.35928C1.68053 1.03779 2.11656 0.857178 2.57122 0.857178H14.5712C15.0259 0.857178 15.4619 1.03779 15.7834 1.35928C16.1049 1.68077 16.2855 2.1168 16.2855 2.57146V6.00003"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.143 12H9.42871"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.8573 8.57141L9.42871 12L12.8573 15.4286"
        />
      </g>
    </svg>
  );
}
